import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
const HomePage = lazy(() => import('../pages/home/home.page'));
const AccountsPage = lazy(() => import('../pages/accounts/accounts.page'));
const ShowCard = lazy(() => import('./../pages/ShowCard'));
const QuickCopy = lazy(() => import('./../pages/QuickCopy'));
import LoginPage from './../pages/login/login.page';

/**
 * Hooks
 */
import useAuth from '../hooks/useAuth';
import Loading from '../components/loading/loading.component';

const Routes = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className={'flex h-screen justify-center items-center'}>
        <Loading />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className={'flex h-screen justify-center items-center'}>
            <Loading />
          </div>
        }
      >
        <Switch>
          <Route exact path={'/copy/:requisite'} component={QuickCopy} />
          <Route exact path={'/:userId/:id'} component={ShowCard} />
          <Route exact path={'/accounts'} component={AccountsPage} />
          <Route exact path={'/login'} component={LoginPage} />
          <Route exact path={'/'} component={HomePage} />
          <Redirect to={'/'} />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

export default Routes;
